module.exports = __webpack_public_path__ + "img/logo.1072c66f.svg";